import { Document } from '@contentful/rich-text-types'
import { Box, Divider, Typography } from '@mui/material'
import { StaticImageData } from 'next/image'

import { convertToComponent } from '@ecm/data/Contentful'
import { SectionType } from '@ecm/ui/component/caseStudies/CaseStudyArticle'
import ContentNav from '@ecm/ui/component/caseStudies/ContentNav'
import Anchor from '@ecm/ui/element/Anchor'
import Color from '@ecm/ui/element/Color'
import ContentfulImage, { ImageType } from '@ecm/ui/element/ContentfulImage'

type CaseStudySidebarProps = {
  activeSection: SectionType
  logoImg: StaticImageData
  organizationName: string
  industry: string[]
  missionDescription: Document
  pdfUrl: string
  onClick: (id: SectionType) => void
}

const CaseStudySidebar = ({
  activeSection,
  logoImg,
  organizationName,
  industry,
  missionDescription,
  pdfUrl,
  onClick,
}: CaseStudySidebarProps) => (
  <Box>
    <ContentfulImage
      imageType={ImageType.NonResponsive}
      src={logoImg}
      alt={`${organizationName} image`}
      layout="fixed"
      priority
    />
    <Divider sx={{ backgroundColor: Color.smoke.normal, mb: '16px', mt: '18px' }} />

    <Typography variant="overline" color={Color.saint.lightest} mb="8px">
      Organization
    </Typography>
    <Typography variant="p3" fontWeight={700}>
      {organizationName}
    </Typography>
    <Divider sx={{ backgroundColor: Color.smoke.normal, my: '16px' }} />

    <Typography variant="overline" color={Color.saint.lightest} mb="8px">
      Industry
    </Typography>

    <Typography variant="p3" fontWeight={700}>
      {industry.join(', ')}
    </Typography>
    <Divider sx={{ backgroundColor: Color.smoke.normal, my: '16px' }} />

    <Typography variant="overline" color={Color.saint.lightest} mb="8px">
      Mission
    </Typography>
    {convertToComponent(missionDescription, 'p3')}

    <Anchor
      href={pdfUrl}
      external
      download
      variant="p3"
      fontWeight={700}
      color={Color.saint.normal}
      sx={{
        border: `1px solid ${Color.saint.normal}`,
        borderRadius: '4px',
        mt: '26px',
        py: '8px',
        textAlign: 'center',
        width: '100%',
      }}
    >
      Download PDF
    </Anchor>

    <ContentNav activeSection={activeSection} onClick={onClick} />
  </Box>
)

export default CaseStudySidebar
